import { render } from "./InfoReportModal.vue?vue&type=template&id=206f0144&scoped=true"
import script from "./InfoReportModal.vue?vue&type=script&lang=js"
export * from "./InfoReportModal.vue?vue&type=script&lang=js"

import "./InfoReportModal.vue?vue&type=style&index=0&id=206f0144&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206f0144"]])

export default __exports__